// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see PushNotificationViewOpenEvent
 */
export var PushNotificationViewOpen = function (_a) {
    var notificationType = _a.notificationType, entityId = _a.entityId;
    return ({
        name: "PushNotification View Open",
        parameters: {
            cdf_entity: "PushNotification",
            cdf_action: "View",
            notification_type: notificationType !== undefined && notificationType !== null ? notificationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entity_id: entityId !== undefined && entityId !== null ? entityId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PushNotificationViewStartEvent
 */
export var PushNotificationViewStart = function (_a) {
    var notificationType = _a.notificationType, entityId = _a.entityId, appState = _a.appState;
    return ({
        name: "PushNotification View Start",
        parameters: {
            cdf_entity: "PushNotification",
            cdf_action: "View",
            notification_type: notificationType !== undefined && notificationType !== null ? notificationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entity_id: entityId !== undefined && entityId !== null ? entityId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            app_state: appState !== undefined && appState !== null ? appState.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PushNotificationViewReadEvent
 */
export var PushNotificationViewRead = function (_a) {
    var notificationType = _a.notificationType, entityId = _a.entityId;
    return ({
        name: "PushNotification View Read",
        parameters: {
            cdf_entity: "PushNotification",
            cdf_action: "View",
            notification_type: notificationType !== undefined && notificationType !== null ? notificationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entity_id: entityId !== undefined && entityId !== null ? entityId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PushNotificationConfirmStartEvent
 */
export var PushNotificationConfirmStart = function (_a) {
    var notificationType = _a.notificationType, entityId = _a.entityId;
    return ({
        name: "PushNotification Confirm Start",
        parameters: {
            cdf_entity: "PushNotification",
            cdf_action: "Confirm",
            notification_type: notificationType !== undefined && notificationType !== null ? notificationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entity_id: entityId !== undefined && entityId !== null ? entityId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PushNotificationConfirmCompleteEvent
 */
export var PushNotificationConfirmComplete = function (_a) {
    var notificationType = _a.notificationType, entityId = _a.entityId;
    return ({
        name: "PushNotification Confirm Complete",
        parameters: {
            cdf_entity: "PushNotification",
            cdf_action: "Confirm",
            notification_type: notificationType !== undefined && notificationType !== null ? notificationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entity_id: entityId !== undefined && entityId !== null ? entityId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PushNotificationConfirmViewBlockerEvent
 */
export var PushNotificationConfirmViewBlocker = function (_a) {
    var notificationType = _a.notificationType, entityId = _a.entityId;
    return ({
        name: "PushNotification Confirm ViewBlocker",
        parameters: {
            cdf_entity: "PushNotification",
            cdf_action: "Confirm",
            notification_type: notificationType !== undefined && notificationType !== null ? notificationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entity_id: entityId !== undefined && entityId !== null ? entityId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PushNotificationConfirmReceiveErrorEvent
 */
export var PushNotificationConfirmReceiveError = function (_a) {
    var notificationType = _a.notificationType, entityId = _a.entityId, logicError = _a.logicError, networkError = _a.networkError, responseCode = _a.responseCode;
    return ({
        name: "PushNotification Confirm ReceiveError",
        parameters: {
            cdf_entity: "PushNotification",
            cdf_action: "Confirm",
            notification_type: notificationType !== undefined && notificationType !== null ? notificationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entity_id: entityId !== undefined && entityId !== null ? entityId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            logic_error: logicError !== undefined && logicError !== null ? logicError.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            network_error: networkError !== undefined && networkError !== null ? networkError.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            response_code: responseCode !== undefined && responseCode !== null ? responseCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PushNotificationDeclineStartEvent
 */
export var PushNotificationDeclineStart = function (_a) {
    var notificationType = _a.notificationType, entityId = _a.entityId;
    return ({
        name: "PushNotification Decline Start",
        parameters: {
            cdf_entity: "PushNotification",
            cdf_action: "Decline",
            notification_type: notificationType !== undefined && notificationType !== null ? notificationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entity_id: entityId !== undefined && entityId !== null ? entityId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PushNotificationDeclineCompleteEvent
 */
export var PushNotificationDeclineComplete = function (_a) {
    var notificationType = _a.notificationType, entityId = _a.entityId;
    return ({
        name: "PushNotification Decline Complete",
        parameters: {
            cdf_entity: "PushNotification",
            cdf_action: "Decline",
            notification_type: notificationType !== undefined && notificationType !== null ? notificationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entity_id: entityId !== undefined && entityId !== null ? entityId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PushNotificationDeclineReceiveErrorEvent
 */
export var PushNotificationDeclineReceiveError = function (_a) {
    var notificationType = _a.notificationType, entityId = _a.entityId, logicError = _a.logicError, networkError = _a.networkError, responseCode = _a.responseCode;
    return ({
        name: "PushNotification Decline ReceiveError",
        parameters: {
            cdf_entity: "PushNotification",
            cdf_action: "Decline",
            notification_type: notificationType !== undefined && notificationType !== null ? notificationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entity_id: entityId !== undefined && entityId !== null ? entityId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            logic_error: logicError !== undefined && logicError !== null ? logicError.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            network_error: networkError !== undefined && networkError !== null ? networkError.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            response_code: responseCode !== undefined && responseCode !== null ? responseCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PushNotificationDeclineDiscardStaleMessageEvent
 */
export var PushNotificationDeclineDiscardStaleMessage = function () { return ({
    name: "PushNotification Decline DiscardStaleMessage",
    parameters: {
        cdf_entity: "PushNotification",
        cdf_action: "Decline",
    }
}); };
